import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CalculationFilter } from '../models/calculation-filter.model';
import { CalculationResult } from '../models/calculation-result.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { VariedadFilter } from '../models/variedad-filter.model';
import { CalculationVariedadResult } from '../models/calculation-variedad-result.model';
import { ArticuloImputadoFilter } from '../models/articulo-imputado-filter.model';
import { ArticuloImputadoResult } from '../models/articulo-imputado-result.model';

@Injectable({
  providedIn: 'root'
})
export class CalculoService {

  private baseUrl = `${environment.apiUrl}/api/calculos`;

  constructor(private http: HttpClient) { }


  ejecutarCalculo(filter: CalculationFilter): Observable<CalculationResult[]> {
    return this.http.post<CalculationResult[]>(`${this.baseUrl}/ejecutar`, filter);
  }

  obtenerVariedades(filter: VariedadFilter): Observable<CalculationVariedadResult[]> {
    return this.http.post<CalculationVariedadResult[]>(`${this.baseUrl}/variedades`, filter);
  }
  obtenerArticulosImputados(filter: ArticuloImputadoFilter): Observable<ArticuloImputadoResult[]> {
  return this.http.post<ArticuloImputadoResult[]>(
    `${this.baseUrl}/articulos-imputados`,
    filter
  );
}

}
